import React from 'react';

function Security() {
  return (
    <div>
      <h1>Security</h1>
      <p>This page is under construction.</p>
    </div>
  );
}

export default Security;
